/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { MCPRegistry, MCPRegistry$inboundSchema } from "./mcpregistry.js";

export type ListRegistriesResponseBody = {
  /**
   * List of MCP registries
   */
  registries: Array<MCPRegistry>;
};

/** @internal */
export const ListRegistriesResponseBody$inboundSchema: z.ZodMiniType<
  ListRegistriesResponseBody,
  unknown
> = z.object({
  registries: z.array(MCPRegistry$inboundSchema),
});

export function listRegistriesResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListRegistriesResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRegistriesResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRegistriesResponseBody' from JSON`,
  );
}
